import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const AcceptStudentEnrollmentMutation = graphql.persisted(
  "AcceptStudentEnrollment",
  graphql(`
    mutation AcceptStudentEnrollment($studentEnrollmentId: ID!) {
      acceptStudentEnrollment(input: {studentEnrollmentId: $studentEnrollmentId}) {
        studentEnrollment { id state }
        userErrors { message path }
      }
    }
  `)
);

export { AcceptStudentEnrollmentMutation };

export function useAcceptStudentEnrollment() {
  return useMutation(AcceptStudentEnrollmentMutation);
}
